import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ISearchDisplayExpert } from '../../../models/search-models';
import { BtxSharedModule } from '../../../../../shared/btx-shared.module';
import { MaterialModule } from '../../../../../shared/patterns/material-module';
import { ExpertNameMaskedModeBetaPipe } from '../../pipes/expert-name-masked-mode.pipe';

@Component({
  selector: 'app-results-display-beta',
  styleUrls: ['./results-display.component.scss'],
  templateUrl: './results-display.component.html',
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    MatCardModule,
    ExpertNameMaskedModeBetaPipe,
    MaterialModule,
    BtxSharedModule,
  ],
})
export class ResultsDisplayBetaComponent implements OnChanges {
  @Input() experts: ISearchDisplayExpert[] = [];
  @Input() maskedMode = false;
  @Output() onContinue = new EventEmitter();

  @ViewChild(MatPaginator, { static: true }) matPaginator: MatPaginator;

  dataSource = new MatTableDataSource<ISearchDisplayExpert>([]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.experts) {
      this.dataSource.paginator = this.matPaginator;
      this.dataSource.data = changes.experts.currentValue;
    }
  }
}
